import './OfferBox.less';

const offerBox = (() =>{
})()

export default offerBox;